var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.client)?_c('span',{staticClass:"role-table"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),(_vm.client)?_c('a',{staticClass:"text-capitalize hide-data",attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]):_c('span',{staticClass:"text-danger text-capitalize"},[_vm._v("Unassigned")])])
}
var staticRenderFns = []

export { render, staticRenderFns }